import { render, staticRenderFns } from "./PackageInfo.vue?vue&type=template&id=59a247e5&scoped=true&"
import script from "./PackageInfo.vue?vue&type=script&lang=js&"
export * from "./PackageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a247e5",
  null
  
)

export default component.exports